"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Cursor utils
 */
const Cursor = {
  /**
   * Moves the cursor to the end of a given div element.
   *
   * @param {HTMLElement} div - The div element to move the cursor to the end of.
   * @param {boolean} options.scroll - Scroll options for an element after moving the cursor.
   */
  moveCursorToEnd(div, options = {}) {
    const range = document.createRange();
    range.selectNodeContents(div);
    range.collapse(false);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    if (options.scroll !== undefined) {
      div.scrollIntoView(options.scroll);
    }
  },
  createRange(node, chars, range) {
    if (!range) {
      range = document.createRange();
      range.selectNode(node);
      range.setStart(node, 0);
    }
    if (chars.count === 0) {
      range.setEnd(node, chars.count);
    } else if (node && chars.count > 0) {
      if (node.nodeType === Node.TEXT_NODE) {
        if (node.textContent.length < chars.count) {
          chars.count -= node.textContent.length;
        } else {
          range.setEnd(node, chars.count);
          chars.count = 0;
        }
      } else {
        for (let lp = 0; lp < node.childNodes.length; lp += 1) {
          range = this.createRange(node.childNodes[lp], chars, range);
          if (chars.count === 0) {
            break;
          }
        }
      }
    }
    return range;
  },
  moveCursorToPosition(div, postion) {
    const selection = window.getSelection();
    const range = this.createRange(div.parentNode, {
      count: postion
    });
    if (range) {
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  },
  isChildOf(node, parentId) {
    while (node !== null) {
      if (node.id === parentId) return true;
      node = node.parentNode;
    }
    return false;
  },
  setCursorAfterElement(targetElement) {
    const range = document.createRange();
    range.setStartAfter(targetElement);
    range.collapse(true);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  },
  insertNodeAtCursor(node) {
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    range.insertNode(node);
  },
  getCaretPosition(parent) {
    const selection = window.getSelection();
    let charCount = -1;
    let node;
    if (!selection.focusNode || !this.isChildOf(selection.focusNode, parent.id)) return charCount;
    node = selection.focusNode;
    charCount = selection.focusOffset;
    if (node.id === parent.id) return parent.selectionStart;
    if (parent.isContentEditable && selection.rangeCount !== 0) {
      const range = selection.getRangeAt(0);
      const preCaretRange = range.cloneRange();
      preCaretRange.selectNodeContents(parent);
      preCaretRange.setEnd(range.endContainer, range.endOffset);
      charCount = preCaretRange.toString().length;
    } else {
      while (node) {
        if (node.id === parent.id) break;
        if (node.previousSibling) {
          node = node.previousSibling;
          charCount += node.textContent.length;
        } else {
          node = node.parentNode;
          if (node === null) break;
        }
      }
    }
    return charCount;
  },
  fixLineBreak(e) {
    e.preventDefault(); // Prevent default browser behavior
    const selection = window.getSelection();
    if (selection) {
      const range = selection.getRangeAt(0);
      const br = document.createElement('br');
      const textNode = document.createTextNode('\u00a0'); // Passing " " directly will not end up being shown correctly
      range.deleteContents();
      range.insertNode(br);
      range.collapse(false);
      range.insertNode(textNode);
      range.selectNodeContents(textNode);
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('delete');

      // Calculate the scroll position needed to make inserted br element visible
      if (selection !== null && selection !== void 0 && selection.anchorNode.getBoundingClientRect) {
        const targetRect = br.getBoundingClientRect();
        const scrollableRect = selection.anchorNode.getBoundingClientRect();

        // Set the scroll position of the scrollable element
        selection.anchorNode.scrollTop = targetRect.top - scrollableRect.top + selection.anchorNode.scrollTop;
      }
      return false;
    }
  }
};
var _default = exports.default = Cursor;